import React, { useCallback, useMemo } from 'react';

import { useAudioContext } from '../context/AudioContext';
import { useDetailViewContext } from '../context/DetailViewContext';
import { useNavigationContext } from '../context/NavigationContext';

import { SectionIDs } from '../data/Sections';
import FocusPoints from '../data/FocusPoints';
import useWindowSize from '../hooks/useWindowSize';

import { ReactComponent as SoundIcon } from '../assets/images/icons/sound.svg';
import styles from './styles.module.scss';


export default function SoundButton(): JSX.Element {
  const { activeSectionID } = useNavigationContext();
  const { activeDetailID, activeFocusID } = useDetailViewContext();
  // TODO: use globalMuted to display a different sound (crossed through?) icon?
  const { globalMuted, muteGlobal } = useAudioContext();
  const { width } = useWindowSize();

  const buttonColor = useMemo(
    () => {
      if (activeDetailID) {
        if (activeFocusID === FocusPoints.None && width > 900) return 'dark';
        else return 'light';
      } else {
        switch (activeSectionID) {
        case SectionIDs.Title:
        case SectionIDs.Joke:
        case SectionIDs.Science:
        case SectionIDs.About:
          return 'light';
        default:
          return 'dark';
        }
      }
    },
    [width, activeSectionID, activeDetailID, activeFocusID],
  );

  const isVisible = useMemo(() => activeSectionID.includes('intro'), [activeSectionID]);

  const onClick = useCallback(
    () => muteGlobal(value => !value),
    [muteGlobal],
  );

  return (
    <button
      className={styles.soundButton}
      data-theme={buttonColor}
      data-visible={JSON.stringify(isVisible)}
      onClick={onClick}
    >
      <SoundIcon data-muted={globalMuted} />
    </button>
  );
}
